Wee.fn.make('easySlide', {
	_construct: function(conf) {
		this.conf = $.extend({
			arrows: 'ref:arrow',
			image: 'ref:slideImage'
		}, conf);

		this.slides = $(this.conf.image, this.conf.el);
		this.arrows = $(this.conf.arrows, this.conf.el);
		this.elements = $(this.conf.image, this.conf.el);
		this.index = 0;

		this.bindEvents();
	},

	bindEvents: function() {
		var scope = this;

		$(scope.arrows).on('click', function(e, el) {
			var index = el.nextSibling === null ? scope.index + 1 : scope.index - 1;

			scope.cycle(index);
		});
	},

	cycle: function(index) {
		if (index >= this.elements.length) {
			this.index = 0;
		} else if (index < 0) {
			this.index = this.elements.length - 1;
		} else {
			this.index = index;
		}

		this.cycleElements();

		if (this.conf.callback) {
			this.conf.callback(this.elements[this.index]);
		}
	},

	cycleElements: function() {
		var disabledClass = '-is-disabled',
				activeClass = 'is-active';

		this.elements.eq(this.index)
			.removeClass(disabledClass)
			.siblings()
			.addClass(disabledClass);
	}
}, {}, {
	instance: false
});